import React, { useEffect, useState } from "react";
import "./Category_section.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Nav } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  getAllCategories,
} from "../../../features/master/masterSlice";

const Category_section = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedCategoryId, setSelectedCategoryId] = useState("");

  const category = useSelector(
    (state) => state?.master?.categories
  );

  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const handleCategoryClick = (id) => {
    setSelectedCategoryId(id);

    navigate(`/categories?category_id=${id}`, {
      state: {
        category_id: id,
      },
    });
  };

  return (
    <section className="Category_section">
      <div className="container">
        <div className="heading_holder">
          <h4 className="heading_text">
            Shop By Category
          </h4>
        </div>

        <Swiper
          modules={[Navigation]}
          navigation={true}
          spaceBetween={15}
          breakpoints={{
            0: {
              slidesPerView: 3,
            },
            576: {
              slidesPerView: 4,
            },
            768: {
              slidesPerView: 5,
            },
            992: {
              slidesPerView: 7,
            },
            1200: {
              slidesPerView: 8,
            },
          }}
        >
          {category?.map((item) => (
            <SwiperSlide key={item?.id}>
              <Nav.Link
                className="category_nav_link"
                onClick={() =>
                  handleCategoryClick(item?.id)
                }
              >
                <div
                  className={`category_card ${
                    selectedCategoryId === item?.id
                      ? "active_category"
                      : ""
                  }`}
                >
                  <div className="category_image_holder">
                    <img
                      src={
                        process.env.REACT_APP_IMG_URL +
                        item?.image
                      }
                      alt={item?.name}
                      className="category_image"
                    />
                  </div>

                  <h6 className="category_name">
                    {item?.name}
                  </h6>
                </div>
              </Nav.Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Category_section;